import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { UserService } from '../../services/user.service';
import { EventEmitterService } from '../../services/event-emitter.service';

@Component({
  standalone: false,
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.css'],
})
export class UserNotificationsComponent implements OnInit, OnDestroy {
  notifications: any;
  unreadNotificationsCount = 0;
  userData: any;
  reloadEvent: Subscription;
  routeSubscription: Subscription;

  constructor(
    private notificationService: NotificationService,
    private accountService: AccountService,
    private errorHandlingService: ErrorHandlingService,
    private router: Router,
    private eventEmitterService: EventEmitterService,
    readonly userService: UserService,
  ) {
    this.routeSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.router.url.indexOf('browser') === -1) {
        this.getNotifications();
      }
    });

    this.reloadEvent = this.eventEmitterService.getDropdownReloadEvent().subscribe(() => {
      this.getNotifications();
    });
  }

  ngOnInit() {
    this.getNotifications();
    this.userData = this.userService.getUserDetails();
    this.userData = this.userService.userData;
  }

  goSeeAll() {
    this.router.navigateByUrl(`/user/${this.userService.userData.uriLabel}`);
  }

  getNotifications() {
    if (this.accountService.isAuthenticated()) {
      this.notificationService.getNotifications('type:APP').subscribe(
        (data) => {
          this.notifications = data?.items;
          this.unreadNotificationsCount = data?.items?.filter((notification) => !notification?.viewed).length;
        },
        (err) => {
          this.errorHandlingService.handleError(err, err.url);
        },
      );
    }
  }

  markAllNotificationsAsRead() {
    this.notificationService.readAllNotifications().subscribe(
      (data: any) => {
        this.getNotifications();
        this.eventEmitterService.sendReloadEvent();
      },
      (err) => {
        this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  readNotification(id: any) {
    this.notificationService.readNotifications(id).subscribe(
      (data) => {
        this.getNotifications();
      },
      (err) => {
        this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  removeClassToBodyForResponsiveMenu(): any {
    const body = document.querySelector('body');
    body.classList.toggle('menu-toggle');
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
